import React from 'react';
import './Button.css';

export default function Button({ children, onClick, disabled, className }) {
    return (
        <button
            className={`${className ? className : "button"}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    )
}